// Maps an account card's bank details to/from the bank fields used on check and
// bank-transfer payment rows (receipts, payment acceptances).

const ROW_BANK_FIELDS = ['bankCode', 'bankName', 'bankBranchCode', 'supplierAccountNumber'];

const BANK_PAYMENT_TYPES = ['checks', 'bankTransactions'];

const readCardField = (card, camel, pascal) => {
  const value = card?.[camel] ?? card?.[pascal];
  return value == null ? '' : String(value).trim();
};

const normalize = (value) => (value == null ? '' : String(value).trim());

export const isBankPaymentType = (itemType) => BANK_PAYMENT_TYPES.includes(itemType);

/** Bank details of the card in payment-row field names, or null when the card has none. */
export const getCardBankDetails = (card) => {
  if (!card) return null;
  const details = {
    bankCode: readCardField(card, 'bankCode', 'BankCode'),
    bankName: readCardField(card, 'bankName', 'BankName'),
    bankBranchCode: readCardField(card, 'branchCode', 'BranchCode'),
    supplierAccountNumber: readCardField(card, 'accountNumber', 'AccountNumber'),
  };
  return Object.values(details).some(Boolean) ? details : null;
};

export const rowHasBankDetails = (row) => ROW_BANK_FIELDS.some((field) => normalize(row?.[field]));

export const rowMatchesCardBankDetails = (row, cardDetails) =>
  !!cardDetails && ROW_BANK_FIELDS.every((field) => normalize(row?.[field]) === cardDetails[field]);

/** Payload for EnumsService.UpdateAccountCardBankDetails built from a payment row. */
export const rowToCardBankDetailsPayload = (row) => ({
  BankCode: normalize(row?.bankCode) || null,
  BankName: normalize(row?.bankName) || null,
  BranchCode: normalize(row?.bankBranchCode) || null,
  AccountNumber: normalize(row?.supplierAccountNumber) || null,
});

/** The card with bank details replaced by the values returned from the API. */
export const withCardBankDetails = (card, saved) => ({
  ...card,
  bankCode: saved?.bankCode ?? saved?.BankCode ?? null,
  bankName: saved?.bankName ?? saved?.BankName ?? null,
  branchCode: saved?.branchCode ?? saved?.BranchCode ?? null,
  accountNumber: saved?.accountNumber ?? saved?.AccountNumber ?? null,
});
